import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { NgClass } from '@angular/common';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  constructor(
    private router: Router,
  ) {

  }

  notLogin(): boolean {
    return !(this.router.url === '/Login' || this.router.url === '/');
  }

}



// WEBPACK FOOTER //
// ./src/app/app.component.ts